import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CampaginTable from '../../common/CampaignTable';
import { CampaignContext } from '../../../contexts/CampaignContext';
import { useContext, useState } from 'react';
import axios from 'axios';
import IResponse from '../../../interfaces/response';

const RecommendHour = () => {
	let { fetchedMedias } = useContext(CampaignContext);
	let { t } = useTranslation();
	const [openModal, setOpenModal] = useState<boolean>(false);
	const [data, setdata] = useState<any | null>(null);
	const headerClassNames = 'text-xs bg-background-paper';
	let tabItem = [
		{
			api: '/admin/campaign-release-time',
			postApi: '/admin/campaign-release-time',
			system_name: 'campaign-release-time',
			label: 'add_recommend_time',
			search: '',
			showBtn: true,
			clickAction: () => {
				if (tabItem[0].system_name === 'campaign-release-time') {
					setOpenModal(!openModal);
				}
			},
			editAction: (id: number) => {
				if (tabItem[0].system_name === 'campaign-release-time') {
					setOpenModal(!openModal);
					axios<IResponse<any>>({
						url: `admin/campaign-release-time/${id}`,
						method: 'get',
					})
						.then(res => {
							if (res.data.success) {
								const data = res.data.data;
								let filterData = fetchedMedias?.find(item => item.system_name === data.media);
								setdata({
									id: id,
									title: data.title,
									media_type: data.media_type,
									media_id: filterData?.id,
									action: 'edit',
								});
							}
						})
						.catch(error => {
							console.error('Request error:', error);
						});
				}
			},
			view: false,
			edit: true,
			delete: true,
			columns: [
				{
					field: 'media',
					flex: 1,
					headerName: t('media'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						let filterMedia = fetchedMedias?.find(item => item.system_name === params.row.media);
						return filterMedia?.title;
					},
				},
				{ field: 'title', flex: 1, headerName: t('hour'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
			],
			route: 'campaigns/view',
		},
	];
	return (
		<Box className="w-full">
			<CampaginTable tabItem={tabItem[0]} setOpenModal={setOpenModal} dataEdit={data} openModal={openModal} />
		</Box>
	);
};

export default RecommendHour;
